package org.hs_soft.runmynesto.pages.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.silk.components.overlay.PopupPlacement
import kotlinx.coroutines.delay
import kotlinx.datetime.Clock
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.config.circleHoverAroundItem
import org.hs_soft.runmynesto.domain.util.Constants
import org.jetbrains.compose.web.css.CSSColorValue
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.px
import kotlin.js.Date


@Composable
fun CustomIcon(
    modifier: Modifier = Modifier,
    focusedColor: CSSColorValue = Theme.ActionFocused.rgb,
    hoveredColor: CSSColorValue = Theme.ActionHover.rgb,
    iconColor: String = Theme.ActionActive.hex,
    icon: String,
    tooltipText: String="",
    tooltipPlacement: PopupPlacement = PopupPlacement.Bottom,
    onIconClick: () -> Unit,
) {
    var showTooltip by remember { mutableStateOf(false) }
    val tooltipId = remember { "tooltip_${Date().getTime()}_${tooltipText.hashCode()}" }

    LaunchedEffect(Unit) {
        delay(100)
        showTooltip = true
    }

    Box(
        modifier = modifier
            .id(tooltipId)
            .cursor(Cursor.Pointer)
            .circleHoverAroundItem(
                focusedColor=focusedColor,
                hoveredColor = hoveredColor,
                onClick = {
                    onIconClick()
                }
            )
            .padding(0.px)
            .position(Position.Relative)
    ) {
        VectorIcon(
            modifier = Modifier.align(Alignment.Center),
            pathData = icon,
            width = Dimen.semiLargeIconSize2,
            height = Dimen.semiLargeIconSize2,
            color = iconColor,
        )

        if (showTooltip && tooltipText.isNotEmpty()) {
            CustomTooltip(
                tooltipId = tooltipId,
                itemTitle = tooltipText,
                placement = tooltipPlacement,
                showDelay = Constants.showTooltipDelay
            )
        }
    }
}